import { SelectedOption } from './selected-option.model';

export class CarouselIndex {
  constructor(
    public cardId: string,
    public cardTitle: string,
    public selectedValues: SelectedOption[],
    public randomizedInd?: boolean,
    public selectedIndex?: number
  ) {}
}
